import axios from "axios";
const API_URL = process.env.REACT_APP_API_URL;

// Función para obtener proyectos por Customer ID
export const getProyectosByCustomerId = async (customerId) => {
  const token = localStorage.getItem("token");
  const response = await axios.get(
    `${API_URL}/customers/${customerId}/proyectos`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
  return response.data;
};

// Función para añadir un proyecto
export const addProyecto = async (customerId, proyecto) => {
  const token = localStorage.getItem("token");
  const response = await axios.post(
    `${API_URL}/customers/${customerId}/proyectos`,
    proyecto,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
  return response.data;
};

// Función para actualizar un proyecto
export const updateProyecto = async (id, proyecto) => {
  const token = localStorage.getItem("token");
  const response = await axios.put(`${API_URL}/proyectos/${id}`, proyecto, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return response.data;
};

// Función para eliminar un proyecto
export const deleteProyecto = async (id) => {
  const token = localStorage.getItem("token");
  const response = await axios.delete(`${API_URL}/proyectos/${id}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return response.data;
};

export const getAllProyectos = async () => {
  const token = localStorage.getItem("token");
  const response = await axios.get(`${API_URL}/proyectos`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return response.data;
};

export const getAllProyectosConPresupuestos = async () => {
  const token = localStorage.getItem("token");
  const response = await axios.get(`${API_URL}/proyectos/withPresupuestos`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return response.data;
};

export const getMarcasByCustomerId = async (customerId) => {
  const token = localStorage.getItem("token");
  const response = await axios.get(
    `${API_URL}/customers/${customerId}/marcas`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
  return response.data;
};

// TAREAS DE TO DO LIST

// Obtener todas las tareas de un proyecto
export const getTareasByProyecto = async (proyectoId) => {
  const token = localStorage.getItem("token");
  const res = await axios.get(`${API_URL}/proyectos/${proyectoId}/tareas`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return res.data;
};

// Obtener todas las tareas globales (con filtro)
export const getAllTareas = async (status = "ongoing") => {
  const token = localStorage.getItem("token");
  const res = await axios.get(`${API_URL}/tareas`, {
    headers: { Authorization: `Bearer ${token}` },
    params: { status },
  });
  return res.data;
};

// Crear una tarea
export const createTarea = async (proyectoId, tarea) => {
  const token = localStorage.getItem("token");
  const res = await axios.post(
    `${API_URL}/proyectos/${proyectoId}/tareas`,
    tarea,
    {
      headers: { Authorization: `Bearer ${token}` },
    }
  );
  return res.data;
};

// Actualizar una tarea
export const updateTarea = async (id, tarea) => {
  const token = localStorage.getItem("token");
  const res = await axios.put(`${API_URL}/tareas/${id}`, tarea, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return res.data;
};

// Eliminar tarea
export const deleteTarea = async (id) => {
  const token = localStorage.getItem("token");
  const res = await axios.delete(`${API_URL}/tareas/${id}`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return res.data;
};

// Buscar proyectos por texto
export const searchProyectos = async (query) => {
  const token = localStorage.getItem("token");
  const response = await axios.get(`${API_URL}/proyectos/search`, {
    params: { q: query },
    headers: { Authorization: `Bearer ${token}` },
  });
  return response.data;
};
